import { Stepper, StepperProps } from '../../../components/navigation/stepper';
import { tokens } from '../../../theme/generated/tokens';
import { mergeSx } from '../../../utils';

export type DialogStepperProps = Omit<StepperProps, 'size'>;

export const DialogStepper = ({
  children,
  sx,
  inverse = true,
  ...props
}: DialogStepperProps) => {
  return (
    <Stepper
      inverse={inverse}
      size="small"
      {...props}
      sx={mergeSx(
        {
          backgroundColor: inverse
            ? tokens.theme.bg.structural.surfaceInverse
            : tokens.theme.bg.structural.surface,
          pb: 32,
          pt: 16,
          px: 36,
        },
        sx
      )}
    >
      {children}
    </Stepper>
  );
};
